import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'statusHardwareFault'
})
export class StatusHardwareFaultPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
